import BaseApi from "../../BaseApi";


export default class DepartmentMembershipRequest extends BaseApi {

    construct() {}

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1") + "department-membership-requests/";
    }

    static async create(payload) {
        return this.post(this.getApiUrl(), payload);
    }

    static async stats() {

        return this.get(this.getApiUrl() + "stats");
    }

    static async index(filters = {}) {
        return this.get(this.getApiUrl(), filters);
    }

    static async all(filters = {}) {
        return this.index({params: filters});
    }

    static async update(id, payload) {
        return this.patch(this.getApiUrl() + id, payload);
    }

    static async delete(id, payload = {}) {
        return this.getAxiosInstance().delete(this.getApiUrl() + id, {
            data: payload,
        });
    }

    static async show(id) {
        return this.get(this.getApiUrl() + id);
    }

    static async approve(id, payload) {
        return this.patch(this.getApiUrl() + id + "/approve", payload);
    }

    static async deny(id, payload) {
        return this.patch(this.getApiUrl() + id + "/deny", payload);
    }

    static async process(id, payload = {}) {
        return this.patch(this.getApiUrl() + id + "/process", payload);
    }

    static async export(payload) {
        return this.post(this.getApiUrl() + "exports", payload);
    }

    static async exports(filters = {}) {
        return this.get(this.getApiUrl() + "exports", { params: filters, });
    }

    static async showExport(id) {
        return this.get(this.getApiUrl() + "exports/" + encodeURIComponent(id));
    }

    static async downloadExport(id) {
        // Use the authenticated instance; a bare file URL has no Bearer token.
        return this.get(this.getApiUrl() + "exports/" + encodeURIComponent(id) + "/download", {
            responseType: "blob",
        });
    }
}
